if ($(".header_article_sticky").length > 0) {
  window.onscroll = function() {
    myFunction();
  };
  var divHeight = $(".article-template__content").outerHeight();
  var sticky = $(".header_article_sticky").offset().top - 120;
  function myFunction() {
    if ($(window).scrollTop() >= sticky && $(window).scrollTop() <= sticky + divHeight) {
      $(".header_article_sticky").addClass("artical_sticky");
    }
    else {
      $(".header_article_sticky").removeClass("artical_sticky");
    }
  }
}

// comments article page
$('body').on('click', '.write-a-comment', function () {
    $('.article-template__comments-fields').slideToggle('fast');
});